<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/admin/task-analyses-revised">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} Templates</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <ng-container *ngIf="canCreate">
        <button
          mat-raised-button
          color="primary"
          class="m-1 mr-2"
          [matMenuTriggerFor]="linkMenu"
          id="add">
          <mat-icon>add</mat-icon>
          New
        </button>

        <mat-menu #linkMenu="matMenu">
          <button mat-menu-item (click)="onAdd('template')">
            Create New Template
          </button>
          <button mat-menu-item (click)="onAdd('snippet')">
            Create New Snippet
          </button>
          <button mat-menu-item (click)="onBuildFromSnippets()" *ngIf="canView">
            Build from Snippets
          </button>
        </mat-menu>

        <button mat-raised-button class="m-1 mr-2" routerLink="/toolbox-talks-templates/importer" matTooltip="Click this button to mass import {{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} templates from a CSV file.">
          <mat-icon>cloud_upload</mat-icon> Import
        </button>
      </ng-container>

      <ng-container *ngIf="canView || canDelete">
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <ng-container *ngIf="canView">
            <button mat-menu-item (click)="onExport('pdf')">
              <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to PDF
            </button>
            <button mat-menu-item (click)="onExport('csv')">
              <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
            </button>
          </ng-container>
          <button *ngIf="canDelete" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>delete</mat-icon> Delete Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect toolbox talks template records." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <ng-container *ngIf="canView">
      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          matTooltip="Search for Toolbox talks records." />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          matTooltip="Run the current search">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </ng-container>
  </div>

</nav>

<div class="alert alert-warning m-2" *ngIf="!canView">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  You do not have permission to view {{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} templates.
  <span *ngIf="canCreate">You can still create new templates using the buttons above.</span>
  <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
</div>

<div class="mat-elevation-z8 scroll-box" *ngIf="canView">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="id" matSortDirection="desc" matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          matTooltip="Toggle sorting by ID">
          #
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
      </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Name
      </th>
      <td mat-cell *matCellDef="let element" class="no-padding text-wrap">
        <span class="clamp-3-lines">
          <strong>{{ element.name }}</strong><br>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="template_type">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Type
      </th>
      <td mat-cell *matCellDef="let element" class="no-padding text-wrap">
        <span>
          <strong>{{ element.template_type?.trim() || 'template' | titlecase }}</strong><br>
        </span>
      </td>
    </ng-container>

      <ng-container matColumnDef="updated_by_user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Last Updated By
        </th>
        <td mat-cell *matCellDef="let toolboxTalk">
          <span *ngIf="toolboxTalk.updated_by_user">
            <a (click)="onUserPublicView(toolboxTalk.updated_by_user.hash)" matTooltip="View User Public Profile">
              {{ toolboxTalk.updated_by_user?.contact_person }}
            </a>
          </span>
        </td>
      </ng-container>

    <ng-container matColumnDef="created_by_user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Created By
      </th>
      <td mat-cell *matCellDef="let toolboxTalk">
          <span *ngIf="toolboxTalk.created_by_user">
            <a (click)="onUserPublicView(toolboxTalk.created_by_user.hash)" matTooltip="View User Public Profile">
              {{ toolboxTalk.created_by_user?.contact_person }}
            </a>
          </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At
      </th>
      <td mat-cell *matCellDef="let toolboxTalk" class="no-padding">
        <span>
          {{ (toolboxTalk.date_created * 1000) | timezoneConvertMedium }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date created">
        Created At (UTC)
      </th>
      <td mat-cell *matCellDef="let toolboxTalk">
        {{ (toolboxTalk.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date modified">
        Last Updated At
      </th>
      <td mat-cell *matCellDef="let toolboxTalk">
        {{ (toolboxTalk.date_modified * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified_UTC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date modified">
        Last Updated At (UTC)
      </th>
      <td mat-cell *matCellDef="let toolboxTalk">
        {{ (toolboxTalk.date_modified * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="500"></th>

      <td mat-cell *matCellDef="let element">
        <button *ngIf="canView" type="button" mat-button [routerLink]="element.id + '/view'">
          View
        </button>

        <button *ngIf="canEdit" type="button" mat-button (click)="onEdit(element)">
          Edit
        </button>

        <button *ngIf="canView && element.id" type="button" mat-button (click)="onExport('pdf', element.id)">
          Export PDF
        </button>

        <button *ngIf="canView"
          type="button" mat-button (click)="onExport('csv', element.id)">
          Export CSV
        </button>

        <button *ngIf="canCreate" type="button" mat-button (click)="onClone(element)">
          Clone
        </button>

        <button *ngIf="canDelete" type="button" mat-button (click)="onRemove(element)">
          Delete
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
